import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BlockChainNFT,
  BlockChainCrowd,
  BlockChainToken,
  BlockChainPayment,
  BlockChainFinancial,
  BlockChainMarketplace,
  BlockChainDefi,
  BlockChainGame,
  BlockChainDAO,
} from "../../../app-constants";
import BgImg from "../../images/services-usa/blockchain-new/blockchain_solution.webp";

function Blockchaincustomsolutions() {
  return (
    <section
      className="blockchain_custom_solutions p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={11}
            lg={10}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Full-fledged and Diversified Custom{" "}
              <span>Blockchain Solutions that We Offer</span>
            </h2>
            <p>
              We are a credible blockchain app development company offering you
              unique blockchain solutions that are tailor-made to suit your
              business needs. Applying the concept of agility, we are keen on
              providing an in-depth understanding of your requirements. This
              approach allows us to grow unique partnerships that promote
              innovation and efficiency and advance your company’s digital
              leadership goals.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="block_custom_main">
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{BlockChainNFT}</div>
                  <div className="block_custom_content">
                    <h5>NFT Development</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{BlockChainCrowd}</div>
                  <div className="block_custom_content">
                    <h5>Crowdfunding Platform Development</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{BlockChainToken}</div>
                  <div className="block_custom_content">
                    <h5>Token Wallets</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{BlockChainPayment}</div>
                  <div className="block_custom_content">
                    <h5>Blockchain Payment Platform</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{BlockChainFinancial}</div>
                  <div className="block_custom_content">
                    <h5>Financial Trading Platform</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">
                    {BlockChainMarketplace}
                  </div>
                  <div className="block_custom_content">
                    <h5>Marketplace Development</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{BlockChainDefi}</div>
                  <div className="block_custom_content">
                    <h5>DeFi Development</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{BlockChainGame}</div>
                  <div className="block_custom_content">
                    <h5>Game Apps</h5>
                  </div>
                </div>
              </div>
              <div className="block_custom_item">
                <div className="block_custom_box">
                  <div className="block_custom_svg">{BlockChainDAO}</div>
                  <div className="block_custom_content">
                    <h5>DAO Development</h5>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Blockchaincustomsolutions;
